import cn from "classnames"
import i18next from "i18next"
import React from "react"

import { Card } from "~/components/Card/Card"

import { Magazine } from "../Magazine/Magazine"
import { Subscription } from "./components/Subscription/Subscription"
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./index.module.css"

type Props = {
  code?: string
  title?: string
  inContactForm?: boolean
  categoriesList?: { id: string; code: string; name: string }[]
  returnValuesType?: "id" | "code" | "name"
  inCareer?: boolean
}

export const SubscriptionMagazine: React.FC<Props> = ({
  code,
  title,
  inContactForm,
  categoriesList,
  returnValuesType,
  inCareer,
}) => {
  const currLang = i18next.language

  return (
    <div className={cn(!inContactForm ? styles.Wrapper : styles.WrapperInContactForm)}>
      {/*{currLang === "ru" && (*/}
      {/*  <Card className={styles.Card}>*/}
      {/*    <Magazine inCareer={inCareer} />*/}
      {/*  </Card>*/}
      {/*)}*/}

      {!inCareer && (
        <Card className={cn(inCareer ? styles.CardSubscriptionInCareer : styles.CardSubscription)}>
          <Subscription
            categoriesList={categoriesList}
            code={code}
            inContactForm={inContactForm}
            returnValuesType={returnValuesType}
            title={title}
          />
        </Card>
      )}
    </div>
  )
}
